import { RootState } from '../../../../reducers'
import { initialState, VersionsSliceState } from './slice'

const versionsSliceSelector = (state: RootState): VersionsSliceState => {
  return state.dock?.sections?.versions ?? initialState
}

export function scrollTopPxSelector(state: RootState): number {
  return versionsSliceSelector(state).scrollTopPx
}

export function pagesLoadedSelector(state: RootState): number {
  return versionsSliceSelector(state).pagesLoaded
}
